import Vue from 'vue'
import axios from 'axios';
import store from '../store/'
import {
  Message
} from 'iview';
Vue.component('Message', Message);
import global_ from './globalVariable';

axios.defaults.timeout = 20000;
axios.defaults.baseURL = '';



//http request 拦截器
axios.interceptors.request.use(

  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    let token = global_.getUrlParam('token') || '';
    // let token='eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmVCYXNlIEpXVCIsImlhdCI6MTUzOTY4MzYyOSwiZXhwIjozMDc5MzY3MjU4LCJhdWQiOiJITFMiLCJzdWIiOiJITFMiLCJkYXRhIjp7Im1lbWJlcl9pZCI6Miwibmlja25hbWUiOiJcdTY1ZTBcdThhMDBcdTc2ODRcdTViZjlcdThiZGQiLCJwaG9uZSI6IjAiLCJjcmVhdGVfdGltZSI6IjIwMTgtMTAtMTUgMTY6NTk6NTkiLCJpc19hZ2VuY3kiOjB9fQ.4JYfPRHx06FHSLFQi9yCmy4lcNDwY46kRjKEMtrddZU';
    if (!token) {
      token = window.sessionStorage.getItem('token') || '';
    } else {
      sessionStorage.setItem('token', token)
    }

    config.data = JSON.stringify(config.data);
    config.headers = {
      // 'Content-Type':'application/x-www-form-urlencoded',
      'Content-Type': 'application/json;charset=utf-8',
      'token': token
    };

    // Toast.loading({
    //     mask: true,
    //     message: '加载中...',
    //     duration:0
    // });
    // if(token){
    //   config.params = {'token':token}
    // }

    return config;
  },
  error => {
    return Promise.reject(err);
  }
);



//http response 拦截器 判断是注册
axios.interceptors.response.use(
  response => {
    var _this=Vue.prototype
    // console.log(_this);
    
    if (response.data.code == 1010001) {
      // _this.$Message.info('你的账号已退出，请重新登录');
      console.log(store);
      //vuex更改store参数，在heaDer.vue里全局监听
      store.commit("setoutSign", true);
      setTimeout(() => {
        store.commit("setSignFlag", true);
      }, 500);
      // _this.$store.commit("setSignFlag", false);
      // sessionStorage.setItem("userInfo", JSON.stringify(""));
      // sessionStorage.removeItem("token");
      // _this.$router.push({ path: "/index" });
        
      // var urlink=window.location.href.split('#')[1];
      // if(urlink!='/startpage'){
      //     localStorage.setItem('urlink',urlink);

      // }
      // window.location.href = global_.wwwUrl;
      //    this.$Message.info('您未登录');
    }else if(response.data.code == 1020000){
      
      store.commit("setoutSign", true);
      setTimeout(() => {
        store.commit("setSignFlag", true);
      }, 500);
    }else if(response.data.code == 10200){
      
      store.commit("setoutSign", true);
      setTimeout(() => {
        store.commit("setSignFlag", true);
      }, 500);
    }else if(response.data.code == 5050006){
      // console.log('5050006');
      // console.log(response.data.data);
      
      store.commit("setNeedMsg", response.data.data);
      store.commit("setNoPermission", true);
    }

    return response;
  },
  error => {
    return Promise.reject(error)
  }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(global_.apiUrl + url, {
        params: params

      })
      .then(response => {
        if (response.data.code == 0) {
          resolve(response.data);
        } else {
          if(response.data.msg=="缺少参数ID"||response.data.msg=="待支付中..."){
            return
          }
          if(response.data.msg){
            if(response.data.msg.indexOf('^') != -1 ||response.data.msg.indexOf('请登录') != -1 ){
              return
            }
          }
          this.$Message.info(response.data.msg);
          resolve(response.data);
          // resolve(response.data);
        }

        // Toast.clear


      })
      .catch(err => {
        this.$Message.info('系统错误，请稍后再试');
        // window.location.href = 'http://www.chbd.net/pc/#/errorPage'
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(global_.apiUrl + url, data)
      .then(response => {
        // console.log(response);
        if(url=='alipayCreateOrder'){
          resolve(response.data);
          return
        }
        
        
        // console.log(response.data);

        if (response.data.code == 0) {
          resolve(response.data);
          // console.log(response.data);

        } else {
          if(response.data.msg=="缺少参数ID"||response.data.msg=="待支付中..."){
            return
          }
          if(response.data.msg){
            if(response.data.msg.indexOf('^') != -1 ){
              return
            }
          }
          this.$Message.info(response.data.msg);
          resolve(response.data);
        }
        // Toast.clear
      }, err => {

        this.$Message.info('系统错误，请稍后再试');
        // window.location.href = 'http://www.chbd.net/pc/#/errorPage'
        reject(err)
      })

  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) { 

  return new Promise((resolve, reject) => {
    axios.patch(global_.apiUrl + url, data)
      .then(response => {
        if (response.data.code == 0) {
          resolve(response.data);
        } else {
          this.$Message.info(response.data.msg);
          resolve(response.data);
        }
        // Toast.clear
      }, err => {

        this.$Message.info('系统错误，请稍后再试');
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(global_.apiUrl + url, data)
      .then(response => {
        if (response.data.code == 0) {
          resolve(response.data);
        } else {

          this.$Message.info(response.data.msg);
          // resolve(response.data);
        }
        // Toast.clear
      }, err => {

        this.$Message.info('系统错误，请稍后再试');
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/http.js